import type { Error } from '../types';

export const mustNotContainSymbols =
  (regexStr: RegExp, message?: Error['message']) =>
  (value: string): Error => ({
    valid: !regexStr.test(value),
    message
  });
